<template>
  <div>
    <h2>Периоды</h2>

    <template v-if="getPeriodsDataSize(periodsData) === 0">
      <el-date-picker
        style="width: 20%"
        v-model="periodsData.newDate"
        value-format="yyyy-MM"
        type="month"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button type="primary" @click="createPeriod"> Добавить</el-button>
    </template>

    <template v-else>
      <el-button type="primary" @click="addPeriod"> Добавить</el-button>
    </template>

    <el-table stripe :data="periodsData">
      <el-table-column label="ID">
        <template #default="{ row }">
          <div>
            {{ row.periodId }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Период">
        <template #default="{ row }">
          <div>
            {{
              (new Date(row.date).getMonth() + 1).toString().padStart(2, "0") +
              "." +
              new Date(row.date).getFullYear()
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Пользователи">
        <template #default="{ row }">
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            :ref="'userTree' + row.periodId"
            :check-on-click-node="true"
            :default-checked-keys="getSelectedUsers(row)"
          />
        </template>
      </el-table-column>

      <el-table-column label="Управление">
        <template #default="{ row }">
          <el-button
            v-if="
              $refs['userTree' + row.periodId] != undefined
                ? $refs['userTree' + row.periodId]
                    .getCheckedKeys()
                    .filter((id) => id != 0).length != row.users.length
                  ? false
                  : true
                : true
            "
            size="mini"
            style="float: left"
            @click="lockPeriod(row)"
            type="success"
            >{{ "Заблокировать" }}
          </el-button>
          <el-button
            v-if="
              $refs['userTree' + row.periodId] != undefined
                ? $refs['userTree' + row.periodId]
                    .getCheckedKeys()
                    .filter((id) => id != 0).length != row.users.length
                  ? true
                  : false
                : false
            "
            size="mini"
            style="float: left"
            @click="lockPeriod(row)"
            type="warning"
            >{{ "Заблокировать" }}
          </el-button>
          <el-button
            size="mini"
            style="float: left"
            @click="reEvalutPeriod(row.periodId)"
            type="primary"
            >{{ "Пересчитать" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";
import Cookies from "js-cookie";

export default {
  name: "periodLockMain",
  mixins: [notification],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      userId: Cookies.get("userId"),
      role: Cookies.get("role"),
      newDate: null,
      defaultProps: {
        children: "children",
        label: "label",
      },
      treeData: [],
    };
  },

  computed: {
    ...mapGetters({
      periodsData: "GETLISTPERIODS",
      allUsersData: "GETTREEUSERS",
    }),
  },

  watch: {
    allUsersData: {
      immediate: true,
      handler(newUsers) {
        this.treeData = this.formatUsers(newUsers);
      },
    },
  },

  methods: {
    getListPeriods() {
      this.$store.dispatch("getTreeUsers").then(() => {
        this.$store.dispatch("getListPeriods").then(() => {
          this.periodsData.forEach((period) => {
            //period.USLength = this.$refs['userTree' + period.periodId].getCheckedKeys().filter((id) => id == 0).length;
            let UserChekId = [];
            period.users.forEach((us) => {
              UserChekId.push(us.userId);
            });
            if (period.users.length == this.allUsersData.length)
              UserChekId.push(0);
            console.log(UserChekId);
            this.$refs["userTree" + period.periodId].setCheckedKeys(UserChekId);
            console.log(
              this.$refs["userTree" + period.periodId].getCheckedKeys()
            );
            console.log(this);
            console.log(this.allUsersData);
            period.selectedUsers = [];
          });
        });
      });
    },

    /*changeThree(row)
    {
      console.log(row);
      row.USLength = this.$refs['userTree' + row.periodId].getCheckedKeys().filter((id) => id == 0).length;
    },*/

    getSelectedUsers(row) {
      row.user;
      return ["userId1", "userId2", "userId3"]; // Этот массив содержит выбранные пользователи
    },
    formatUsers(users) {
      return [
        {
          label: "Все",
          id: 0,
          children: users.map((user) => ({
            id: user.userId,
            label: user.username,
          })),
        },
      ];
    },

    getPeriodsDataSize(periodsData) {
      return periodsData.length;
    },
    /*
    canLockPeriod(index) {
      if (!this.periodsData || this.periodsData.length === 0) {
        return false;
      }
      if (index === 0) {
        return true;
      }
      const previousPeriod = this.periodsData[index - 1];
      return previousPeriod.lock === true;
    },*/

    addPeriod() {
      let data = {
        periodInfo: {
          lock: false,
        },
      };
      this.$store.dispatch("addNewPeriod", data).then(() => {
        this.$store.dispatch("getListPeriods");
      });
    },

    createPeriod() {
      let data = {
        periodInfo: {
          dateInfo: this.periodsData.newDate,
        },
      };
      this.$store.dispatch("createNewPeriod", data).then(() => {
        this.$store.dispatch("getListPeriods");
      });
    },

    lockPeriod(row) {
      const treeRef = this.$refs["userTree" + row.periodId];
      let selectedUsers = treeRef.getCheckedKeys().filter((id) => id !== 0);
      let data = {
        periodId: row.periodId,
        userIds: selectedUsers,
      };
      console.log(data);
      this.$store.dispatch("lockPeriod", data).then(() => {
        this.$store.dispatch("getListPeriods");
      });
    },
    reEvalutPeriod(periodId) {
      this.$store.dispatch("reEvalutPeriod", periodId);
    },
  },

  mounted() {
    this.getListPeriods();
    this.$store.dispatch("getListPeriods");
  },
};
</script>

<style scoped>
.table {
  word-wrap: normal;
}
</style>
